import {redirectAsPost} from "../api/Requests";
import {usePlayMakersConfig} from "../PlayMakersProvider";

export const useIdServer = (): any => {
  const idServer = new IdServer(usePlayMakersConfig());
  const {redirectSteam, redirectTikTok, redirectYouTube} = idServer;
  return {
    redirectSteam,
    redirectTikTok,
    redirectYouTube
  };
};

class IdServer {
  idServerUrl;
  projectId;

  constructor(config: any) {
    this.idServerUrl = config.IDSERVER_BASEURL;
    this.projectId = config.PROJECT_ID;
  }

  call = async({url, callbackUrl, ...rest}: any) => {
    callbackUrl = window.location.origin + (callbackUrl || "");
    if(this.projectId) callbackUrl = `${callbackUrl}?projectId=${this.projectId}`;
    console.log("cbUrl", callbackUrl);
    console.log("projectId", this.projectId);
    return await redirectAsPost(`${this.idServerUrl}${url}`, {...rest, callbackUrl});
  };

  exports = ["redirectSteam", "redirectTikTok", "redirectYouTube"];


  // ------------- STEAM -------------
  redirectSteam = async(questId?: string): Promise<any> => {
    const response: any = await this.call({
      callbackUrl: `${questId ? `/quests/${questId}` : "/quests"}`,
      url: "/auth/redirect/steam"
    });
    return response;
  };

  // ------------- TIKTOK -------------

  redirectTikTok = async(questId?: string): Promise<any> => {
    const response: any = await this.call({
      callbackUrl: `${questId ? `/quests/${questId}` : "/quests"}`,
      url: "/auth/redirect/tiktok"
    });
    return response;
  };

  // ------------- YOUTUBE -------------

  redirectYouTube = async(questId?: string): Promise<any> => {
    const response: any = await this.call({
      callbackUrl: `${questId ? `/quests/${questId}` : "/quests"}`,
      url: "/auth/redirect/youtube"
    });
    return response;
  };

}
